import { Role } from '@99designs/common/apps/global-nav/consts';
import { Site } from '__generated__/Site';
import React from 'react';

interface CreateContext {
    site?: Site;
    role: Role;
}

export default React.createContext<CreateContext>({
    role: 'logged-out',
});
